// extracted by mini-css-extract-plugin
export default {"container":"resource-indent_container__J7qGu","img-container":"resource-indent_img-container__CC+g-"};